import { inject, Injectable } from "@angular/core";
import { ContextService } from "@shared/services/context.service";
import { CartService } from "@shared/services/cart.service";
import { catchError, first, iif, map, Observable, of, switchMap } from "rxjs";
import { SystemService } from "@shared/services/system.service";
import { FavoriteProductsService } from "@shared/services/favorite-products.service";
import { CustomerService } from "@shared/services/customer.service";

@Injectable({
  providedIn: "root",
})
export class ClientStateService {
  private readonly contextService = inject(ContextService);
  private readonly cartService = inject(CartService);
  private readonly favoriteProductsService = inject(FavoriteProductsService);
  private readonly systemService = inject(SystemService);
  private readonly customerService = inject(CustomerService);

  initCustomerState(): Observable<boolean> {
    return this.contextService.getContext().pipe(
      switchMap((context) => iif(() => !!context.customer, this.customerService.getCustomerInformation(), of(false))),
      catchError(() => of(false)),
      map(Boolean),
    );
  }

  initClientState(): void {
    this.cartService.getCart().pipe(first()).subscribe();
    this.favoriteProductsService.getFavoritesList().pipe(first()).subscribe();
    this.systemService.getCountries().pipe(first()).subscribe();
    this.systemService.getSalutations().pipe(first()).subscribe();
    this.systemService.getLanguages().pipe(first()).subscribe();
  }
}
